import { Component, computed, input, model, output } from '@angular/core'
import { TbButtonComponent } from '../tb-button/tb-button.component'

import { TbIconComponent } from '../tb-icon/tb-icon.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { TbTooltipComponent } from '@components-library/tb-tooltip/tb-tooltip-component/tb-tooltip.component'

@Component({
    selector: 'app-tb-accordion',
    templateUrl: './tb-accordion.component.html',
    imports: [MatExpansionModule, TbIconComponent, TbButtonComponent, TbTooltipComponent],
})
export class TbAccordionComponent {
    readonly title = input.required<string>()
    readonly background = input(false)
    readonly description = input('')
    readonly settingsShow = input(false)
    readonly settingsDisabled = input(false)
    readonly messageOnDisabled = input('')
    readonly expanded = model(false)

    readonly callAdvanced = output()

    headerBackgroundDisplaying = computed(() =>
        this.background() ? 'bg-neutral2' : 'hover:bg-neutral3',
    )
    headerPaddingDisplaying = computed(() => (this.background() ? 'p-4' : 'p-2'))
    headerRadiusDisplaying = computed(() => (this.background() ? 'rounded-lg' : 'rounded'))
    bodyBackgroundDisplay = computed(() => (this.background() ? 'bg-neutral2' : ''))
    contentBackgroundDisplay = computed(() => (this.background() ? 'bg-neutral1' : ''))
}
